/*
 * @Description: 
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: zcy
 * @LastEditTime: 2022-01-18 14:41:53
 */
import http from "@/axios/index";
/**接口根路经标识 */

// 获取列表
export function initPageList(data) {
  const url = `/outFishProfitOrg/searchOutFishProfitOrgList`
  return http.post(url, data)
}


// 获取所有机构--单位利润计划与实际比
export function getAllJiGou(rootId){
  const url = `/desktopReport/queryIndexBase/${rootId}`
  return http.get(url)
}

// 获取所有批次--单位利润计划与实际比
export function getAllPiCi(rootId){
  const url = `/desktopReport/queryIndexPerioy/${rootId}`
  return http.get(url)
}
// 获取所有品类--单位利润计划与实际比
export function getAllPinLei(rootId){
  const url = `/desktopReport/queryIndexType/${rootId}`
  return http.get(url)
}
// 获取所有品种--单位利润计划与实际比
export function getAllPinZhong(rootId){
  const url = `/desktopReport/queryIndexBreed/${rootId}`
  return http.get(url)
}


